import React, { Fragment } from 'react';
import axios from 'axios';
import { Input, Form, Segment, Button, Checkbox, Header, Table, Loader, Popup, Icon, Label } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import moment, { now } from 'moment';
import { DateTimePicker } from 'react-widgets';

import ContractPauses from './ContractPauses';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class EmployeeContractInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: null,
            main: null,
            contractInfo: [],
            contract: null,

            editMode: false,

            number: null,
            date: null,

            active: true,

            contractTypes: [],
            contractType: null,

            startDate: null,
            endDate: null,
            fullTime: false,
            comment: null,
            startDateP: null,
            endDateP: null,

            numberErr: false,
            dateErr: false,
            termErr: false,
            startDateErr: false,
            startDatePErr: false,
            endDatePErr: false,
            endDateErr: false,

            optLockContract: null,
            idContract: null,

            newContract: false,

            showPause: false,

            contractId: null,
            loading: true

        };

        this.editContract = this.editContract.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getContracts = this.getContracts.bind(this);
        this.getContractPauses = this.getContractPauses.bind(this);
    }


    componentWillMount() {
        this.setState({
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true'
        });

        this.getContracts();

        axios.get('contract-types')
            .then(res => {
                this.setState({
                    contractTypes: res.data.map(el => (
                        {
                            ...el, key: el.id, value: el.id, text: el.name
                        }
                    ))
                });
            })
            .catch(err => {
                console.log('Failed to fetch contract types.');
            });
    }

    getContracts() {
        axios.get(`employment-contract/${JSON.parse(localStorage.getItem('employee')).id}/`)
            .then(res => {
                this.setState({ contractInfo: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch employment contract info.');
            });
    }

    editContract() {
        this.setState({ loader: true });
        const {
            number, date, contractType, startDate, endDate, fullTime, comment, startDateP, endDateP, optLockContract, idContract, active, newContract
        } = this.state;

        if (!number || !date || !contractType || !startDate || (contractType !== 1 && !endDate)) {
            toast('Niste unijeli obavezna polja.');
            if (!number) { this.setState({ numberErr: true }); } else { this.setState({ numberErr: false }); }
            if (!date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!contractType) { this.setState({ termErr: true }); } else { this.setState({ termErr: false }); }
            if (!startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (contractType === 1 && !endDate) { this.setState({ endDateErr: true }); } else { this.setState({ endDateErr: false }); }
        } else {
            let obj = {
                number,
                date,
                contractType: { id: contractType },
                startDate,
                endDate,
                fullTime,
                active,
                comment
            };

            if (!newContract) obj = { ...obj, optLock: optLockContract, id: idContract };

            if (newContract) {
                axios.post(`employment-contract/${this.state.employee.id}/`, { ...obj })
                    .then(res => {
                        this.setState({
                            editMode: false,
                            contract: null,
                            newContract: false,
                            number: null,
                            date: null,
                            contractType: null,
                            startDate: null,
                            endDate: null,
                            fullTime: false,
                            active: null,
                            loader: false
                        });
                        this.getContracts();
                        toast('Dodavanje ugovora je uspješno izvršeno.');
                    })
                    .catch(err => {
                        this.setState({ loader: false });
                        toast('Došlo je do greške! Dodavanje ugovora nije uspješno izvršeno.');
                    });
            } else {
                axios.put('employment-contract/', { ...obj })
                    .then(res => {
                        this.setState({
                            editMode: false,
                            contract: null,
                            newContract: false,
                            number: null,
                            date: null,
                            contractType: null,
                            startDate: null,
                            endDate: null,
                            fullTime: false,
                            active: null,
                            loader: false
                        });
                        this.getContracts();
                        toast('Izmjena ugovora je uspješno izvršena.');
                    })
                    .catch(err => {
                        this.setState({ loader: false });
                        toast('Došlo je do greške! Izmjena ugovora nije uspješno izvršena.');
                    });
            }
        }
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    getContractPauses(contractId, number) {
        this.setState({ showPause: true, contractId, number });
    }


    render() {
        const {
            employee, main, contractInfo, contract
        } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {this.state.showPause &&
                    <ContractPauses
                        contractId={this.state.contractId}
                        close={() => this.setState({ showPause: false })}
                        number={this.state.number}
                    />}

                <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Broj ugovora</Table.HeaderCell>
                            <Table.HeaderCell width="1">Aktivan</Table.HeaderCell>
                            <Table.HeaderCell>Tip ugovora</Table.HeaderCell>
                            <Table.HeaderCell width="1">Puno radno vrijeme</Table.HeaderCell>
                            <Table.HeaderCell>Datum zaključenja ugovora</Table.HeaderCell>
                            <Table.HeaderCell>Početak radnog odnosa</Table.HeaderCell>
                            <Table.HeaderCell >Kraj radnog odnosa</Table.HeaderCell>
                            {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                            <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Dodaj ugovor"
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({ newContract: true, editMode: true, active: true })}
                                        />}
                                />
                            </Table.HeaderCell>}
                        </Table.Row>
                    </Table.Header>
                    {(contractInfo.length || this.state.newContract) ? <Table.Body>
                        {this.state.newContract && <Table.Row >
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field
                                        required
                                        error={this.state.numberErr}
                                        control={Input}
                                        placeholder="Unesite broj ugovora"
                                        value={this.state.number}
                                        name="number"
                                        onChange={this.handleInputChange}
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" textAlign="center">
                                <Form>
                                    <Checkbox
                                        checked={this.state.active}
                                        value={this.state.active}
                                        onChange={(e) => this.setState({ active: !this.state.active })}
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Dropdown
                                        selection
                                        options={this.state.contractTypes}
                                        onChange={this.handleInputChange}
                                        value={this.state.contractType}
                                        name="contractType"
                                        placeholder="Odaberite tip ugovora"
                                        search
                                        fluid
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" textAlign="center">
                                <Form>
                                    <Checkbox
                                        checked={this.state.fullTime}
                                        value={this.state.fullTime}
                                        onChange={(e) => this.setState({ fullTime: !this.state.fullTime })}
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field
                                        required
                                        error={this.state.dateErr}
                                    >
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'date')}
                                            value={this.state.date ? new Date(this.state.date) : this.state.date}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" >
                                <Form>
                                    <Form.Field
                                        required
                                        error={this.state.startDateErr}
                                    >
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'startDate')}
                                            value={this.state.startDate ? new Date(this.state.startDate) : this.state.startDate}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" >
                                <Form>
                                    <Form.Field
                                        disabled={this.state.contractType === 1}
                                        required={this.state.contractType === 1}
                                        error={this.state.Err}
                                    >
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'endDate')}
                                            value={this.state.endDate ? new Date(this.state.endDate) : this.state.endDate}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell textAlign="center" verticalAlign="middle" width={this.state.editMode ? '2' : '1'}>
                                <Button
                                    disabled={this.state.loader}
                                    loading={this.state.loader}
                                    onClick={this.editContract}
                                    circular
                                    color="blue"
                                    icon="check"
                                    size="small"
                                />
                                <Button
                                    onClick={() => this.setState({
                                        editMode: false,
                                        contract: null,
                                        newContract: false,
                                        number: null,
                                        date: null,
                                        contractType: null,
                                        startDate: null,
                                        endDate: null,
                                        fullTime: false,
                                        active: null
                                    })}
                                    disabled={this.state.loader}
                                    circular
                                    icon="close"
                                    size="small"
                                    basic="true"
                                    color="blue"
                                />

                            </Table.Cell>
                        </Table.Row>}
                        {contractInfo.map((el, index) =>
                            (<Table.Row key={index} >
                                <Table.Cell verticalAlign="middle">
                                    {contract === index ?
                                        <Form noValidate>
                                            <Form.Field
                                                required
                                                error={this.state.numberErr}
                                                control={Input}
                                                placeholder="Unesite broj ugovora"
                                                value={this.state.number}
                                                name="number"
                                                onChange={this.handleInputChange}
                                            />
                                        </Form>
                                        : el.number
                                    }
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {contract === index ?
                                        <Form>
                                            <Checkbox
                                                checked={this.state.active}
                                                value={this.state.active}
                                                onChange={(e) => this.setState({ active: !this.state.active })}
                                            />
                                        </Form>
                                        : el.active ? 'DA' : 'NE'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {contract === index ?
                                        <Form>
                                            <Form.Dropdown
                                                selection
                                                options={this.state.contractTypes}
                                                onChange={this.handleInputChange}
                                                value={this.state.contractType}
                                                name="contractType"
                                                placeholder="Odaberite tip ugovora"
                                                search
                                                fluid
                                            />
                                        </Form>
                                        : el.contractType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {contract === index ?
                                        <Form>
                                            <Form.Field>
                                                <Checkbox
                                                    checked={this.state.fullTime}
                                                    value={this.state.fullTime}
                                                    onChange={(e) => this.setState({ fullTime: !this.state.fullTime })}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.fullTime ? 'DA' : 'NE'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {contract === index ?
                                        <Form>
                                            <Form.Field
                                                required
                                                error={this.state.dateErr}
                                            >
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'date')}
                                                    value={this.state.date ? new Date(this.state.date) : this.state.date}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.date ? moment(el.date).format('D. M. YYYY.') : ''}
                                </Table.Cell>

                                <Table.Cell verticalAlign="middle" >
                                    {contract === index ?
                                        <Form>
                                            <Form.Field
                                                required
                                                error={this.state.startDateErr}
                                            >
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'startDate')}
                                                    value={this.state.startDate ? new Date(this.state.startDate) : this.state.startDate}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.startDate && moment(el.startDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" error={moment(el.endDate) <= moment(now())}>
                                    {contract === index ?
                                        <Form>
                                            <Form.Field
                                                disabled={this.state.contractType === 1}
                                                required={this.state.contractType === 1}
                                                error={this.state.Err}
                                            >
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'endDate')}
                                                    value={this.state.endDate ? new Date(this.state.endDate) : this.state.endDate}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.endDate && <Fragment>


                                            {moment(el.endDate).format('D. M. YYYY.')}
                                            <span style={{ float: 'right' }}> {moment(el.endDate) <= moment(now()) && <Label prompt size="mini" color="red" basic> <Icon name="attention" /> Isteklo</Label>}</span>

                                        </Fragment>

                                    }
                                </Table.Cell>
                                {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell textAlign="center" verticalAlign="middle">
                                    {(this.state.editMode && contract === index) ?
                                        <div>
                                            <Button
                                                onClick={this.editContract}
                                                circular
                                                color="blue"
                                                icon="check"
                                                size="small"
                                            />
                                            <Button
                                                onClick={() => this.setState({
                                                    editMode: false,
                                                    contract: null,
                                                    number: null,
                                                    date: null,
                                                    contractType: null,
                                                    startDate: null,
                                                    endDate: null,
                                                    fullTime: null,
                                                    active: null

                                                })}
                                                circular
                                                icon="close"
                                                size="small"
                                                basic="true"
                                                color="blue"
                                            />
                                        </div>
                                        : <div><Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    onClick={() => this.setState({
                                                        editMode: true,
                                                        contract: index,
                                                        number: el.number,
                                                        date: el.date,
                                                        contractType: el.contractType.id,
                                                        startDate: el.startDate,
                                                        endDate: el.endDate,
                                                        fullTime: el.fullTime,
                                                        active: el.active,
                                                        optLockContract: el.optLock,
                                                        idContract: el.id
                                                    })}
                                                    basic="true"
                                                    color="green"
                                                    circular
                                                    icon="pencil"
                                                    size="small"
                                                />
                                            }
                                        />

                                            <Popup
                                            content="Mirovanja"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    icon="pause"
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    onClick={() =>
                                                        this.setState({ showPause: false }, () => this.getContractPauses(el.id, el.number))

                                                    }
                                                />}
                                        />
                                        </div>}
                                </Table.Cell>}
                            </Table.Row>
                            ))}

                    </Table.Body> :
                        <Table.Body>
                        <Table.Row>
                                <Table.Cell
                                    colSpan={this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' ? '8' : '7'}
                            >
                                    Nema unesenih podataka o ugovorima.
                            </Table.Cell>
                            </Table.Row>
                    </Table.Body>}
                </Table>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/EmployeeContractInfo.js